import { Col, Modal, Row } from 'react-bootstrap';
import Button from 'components/base/Button';
import Badge from 'components/base/Badge';
import EditableDetailsField from 'components/common/EditableDetailsField';
import { PitchDeck } from 'data/pitchdecks';
//import { useNavigate } from 'react-router-dom';
//import projectsService, { addProject } from 'services/project';

interface TemplateViewModalModalProps {
  handleClose: () => void;
  pitchdeck: PitchDeck;
  show: boolean;
}

const TemplateViewModal = ({
  handleClose,
  show,
  pitchdeck
}: TemplateViewModalModalProps) => {
  //const navigate = useNavigate();
  //const handleCreateButtonClick = async () => {};

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      contentClassName="overflow-hidden"
    >
      <Modal.Header className="position-relative p-0">
        <input type="file" id="projectCoverInput" className="d-none" />
        <label
          className="position-absolute top-0 start-0"
          htmlFor="projectCoverInput"
        ></label>
        <img
          src={pitchdeck.thumbnail}
          alt="cover"
          className="w-100"
          style={{ minHeight: 150, maxHeight: 280 }}
        />
      </Modal.Header>
      <Button
        className="position-absolute top-0 end-0 mt-3 me-3"
        variant="phoenix-warning"
      >
        Use this template
      </Button>
      <Button variant="phoenix-primary" className="px-5" onClick={handleClose}>
        Cancel
      </Button>
      <Modal.Body className="p-0">
        {/* <ActionSection /> */}

        <Row className="g-0">
          <Col xs={12} xl={5} className="border-end border-300 bg-100">
            <div className="px-5 px-lg-6 py-4 bg-white">
              <h3 className="fw-bolder lh-sm mb-5">{pitchdeck.title}</h3>

              <div className="mb-5">
                <h6 className="text-800 mb-2">Tags</h6>
                <div className="d-flex gap-2 align-items-center">
                  <Badge variant="phoenix" bg="info" className="fs-10">
                    Freeclimbing
                  </Badge>
                  <Badge variant="phoenix" bg="warning" className="fs-10">
                    Peril
                  </Badge>
                  <Badge variant="phoenix" bg="success" className="fs-10">
                    Danger
                  </Badge>
                </div>
              </div>
              <EditableDetailsField className="mb-6">
                The female circus horse-rider is a recurring subject in
                Chagall's work. In 1926 the art dealer Ambroise Vollard invited
                Chagall to make a project based on the circus. They visited
                Paris's historic Cirque d'Hiver Bouglione together; Vollard lent
                Chagall his private box seats. Chagall completed 19 gouaches
              </EditableDetailsField>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default TemplateViewModal;
